const $ = window.jQuery;

const stickyKit = {
  stickElement(ele, offset) {
    $(ele).stick_in_parent({ offset_top: offset, recalc_every: 2 });
  },

  unstickElement(ele) {
    $(ele).trigger('sticky_kit:detach');
  },

  withinBreakpoint(low, high) {
    return ($(window).width() > low && $(window).width() < high);
  },

  init() {
    $('.stick-in-parent').each(function () {
      const ele = this;

      let low = $(ele).attr('data-break-point-min') || 767;
      let high = $(ele).attr('data-break-point-max') || 10000;
      let offset = $(ele).attr('data-offset') || 0;
      
      low = parseInt(low);
      high = parseInt(high);
      offset = parseInt(offset);

      if (!stickyKit.withinBreakpoint(low, high)) return;

      stickyKit.stickElement(ele, offset);
    });
  },
};

export default stickyKit;
